module.exports = __webpack_public_path__ + "components/flag/static/square/hn-f2196ae252ed7286c03ca58f4d8437b1.svg";